import { BlackJackGameState, GameResultState } from './black_table_data';
import ModelData, { IUserData } from '../../../public/model_data';
import { BlackJack } from '../../net/proto/proto_blackjack_game';
import ViewBase from '../../../../framework/core/mvvm/view_base';
import BlackJackTableLogic from './blackjack_table_logic';
import BlackJackTableView from './blackjack_table_view';
import GameUtil from '../../../../utility/game_util';
import { CountUp } from '../../../../lib/countUp';
import UserDataManager from '../../../../manager/user_manager';
import ModuleManager from '../../../../framework/core/module_manager';
import ChatInfo from '../../../table/module/tablechat/chatinfo';
import OhterChatInfo from '../../../table/module/tablechat/ohter_chat_info';
import LanguageManager from '../../../../manager/language_manager';

const {ccclass, property} = cc._decorator;

@ccclass
export default class BlackJackTableSeatView extends ViewBase {
    
    
    @property(cc.Label)
    coinTxt: cc.Label = null;

    @property(cc.Label)
    clockTimeTxt: cc.Label = null;

    @property(cc.Node)
    changeCoinBg: cc.Node = null;

    @property(cc.Label)
    changeCoinTxt: cc.Label = null;

    @property(cc.Sprite)
    playerIcon: cc.Sprite = null;


    @property(cc.Label)
    playerNameTxt: cc.Label = null;

    @property(cc.Node)
    coinNode: cc.Node = null;

    @property(cc.Node)
    stateBg: cc.Node = null;
   
    @property(cc.Label)
    stateTxt: cc.Label = null;
    
    chipPos: cc.Node = null;

    @property(cc.Node)
    noPlay: cc.Node = null;

    @property(cc.Animation)
    winAction: cc.Animation = null;
    
    
    //人物倒计时边框
    @property(cc.Sprite)
    countFrame: cc.Sprite = null;

    @property(cc.Node)
    clickNode: cc.Node = null;
    

    //人物倒计时边框
    @property(cc.Sprite)
    seatNoSp: cc.Sprite = null;

    @property(cc.SpriteAtlas)
    spriteAtlasSeatNo: cc.SpriteAtlas = null

    @property(cc.Node)
    winBg: cc.Node = null

    @property(cc.Node)
    loseBg: cc.Node = null


    private parentPos:cc.Node;
    
    private changeStartPos:cc.Vec2=cc.v2(-5,-82)
    private blackjackLogic:BlackJackTableLogic=null
    private blackJackView:BlackJackTableView=null
    posInfo:BlackJack.IPosInfo=null;    

    intervalID=0;
    countTotalTime=30
    passTime=0
    seatNo=0
    countMoney:number=0
    isPlaying:boolean=false
    lastMoney:number=0
    posInfoIdx=-1;

    start () {

    }
    onLoad(){
        this.clickNode.on(cc.Node.EventType.TOUCH_END,this.clickPlayIcon,this)
        
    }
    clickPlayIcon()
    {
        
        ModuleManager.instance.showEmojiModule(this.posInfo.playerId,this.blackJackView._moduleBase.node.name)
    }
    reset(){
        
        this.isPlaying=false;
        this.showState("",false)
        this.showResult(false);
        this.countFrame.node.active=false;
        this.playerNameTxt.string=""
        this.coinTxt.string=""
        this.posInfo=null
        this.countMoney=0
        this.noPlay.active=false;
        this.showState("",false)
        this.winAction.node.active=false;
    }
    
    
    
    addPosInfo(posInfo:BlackJack.IPosInfo)
    {
        if(this.posInfo==null || this.posInfo.playerId!=posInfo.playerId)
        {
            
            this.posInfo=posInfo
            
            this.checkMask()
        }
            
        
        // this.posInfo.coinBalance=Math.round(this.posInfo.coinBalance * 100) / 100
        // this.posInfo.coinBalance=BlackJackUtility.addThousands(this.posInfo.coinBalance);
        
    }
    checkMask() {
        

        if(this.blackjackLogic.gameState==BlackJackGameState.Beting)
        {
            this.noPlay.active=false;
        }
        else
        {
            
            if(this.posInfo && this.posInfo.base!=0)
            { 
                
                
                this.noPlay.active=false
                return;
            }
            this.noPlay.active=true;
        }
        
        
        
    }
    //下注后 修改玩家的金额
    modifyPosInfoBet(posInfo:BlackJack.IPosInfo)
    {
    //     optional uint32 pos = 1;//1~5 左手位 6~10右手位 (pos -1 ) % 5 + 1
    //     optional int32 player_id = 3; //该座位下底注的玩家ID，即主玩家

    // optional int32 insurance = 4;//保险金
    // //保险标志 false还未进行买保险的操作 true 已经进行了买保险的操作
    // //GameInfo.state == 3时根据以下标志决定是否询问用户是否购买保险
    // optional bool insurance_flag = 5;
    // optional int32 base = 2; //该位置主玩家基础下注数额
    // optional int32 pair = 7;//该位置主玩家完美对子下注数额
    // optional int32 b21p3=8;//该位置主玩家21+3下注数额
    // optional int32 coin_balance = 20; //主玩家金币余额
    // optional bool is_main_seat= 9; //该位置是否为玩家的落座位置
    // optional CardInfo card_info = 6;
        this.posInfo.coinBalance=posInfo.coinBalance
        if(posInfo.base!=0)
        {
            this.posInfo.base=posInfo.base
        }
        if(posInfo.pair!=0)
        {
            this.posInfo.pair=posInfo.pair
        }
        if(posInfo.b21p3!=0)
        {
            this.posInfo.b21p3=posInfo.b21p3
        }
        this.showPanel();
    }
    showPanel()
    {
        this.node.active=true;
         
        if(this.posInfo==null || !this.posInfo.isMainSeat)
        {
            this.node.active=false
        }
        else if(this.posInfo.isMainSeat)
        {
            this.node.active=true
            UserDataManager.setUserJsonData(this.posInfo.userJson)
            this.getUserData(this.posInfo.playerId, (data : IUserData)=> {
                this.playerNameTxt.string = GameUtil.cutStr(data.name) 
                this.playerIcon.spriteFrame = data.avatarSprite
                
                //this.playerItems[playerObjIndex].Icon.node
            })
            let num=this.posInfo.coinBalance
            num=Math.round(num * 100) / 100

            this.setPlayerCoin(this.posInfo.playerId, num);
                       
            //this.coinTxt.string=GameUtil.currencyFormatting(num)            
            
        }
        
    }
    
    setSeatNo(num:number)
    {
        this.seatNo=num;
       
        this.seatNoSp.spriteFrame=this.spriteAtlasSeatNo.getSpriteFrame("seatNo_"+this.seatNo)
        // this.seatNoList[num-1].active=true;
        // let txt:cc.Label=this.seatDownBtn.node.getChildByName("Label").getComponent(cc.Label);
        // txt.string="坐下"+this.seatNo.toString();
    }
    
    getSeatNo()
    {
        return this.seatNo
    }
    
    showResult(show:boolean)
    {
       
        this.changeCoinBg.active=show;
        if(show)
        {
            this.changeCoinBg.position=this.changeStartPos;
            this.winBg.active=true
            this.loseBg.active=false
            if(this.countMoney==0)
            {
                this.changeCoinTxt.string="0"
            }
            else 
            {
                // this.countMoney=Math.round(this.countMoney * 100) / 100
                this.changeCoinTxt.string=GameUtil.currencyFormatting(this.countMoney)
                if(this.countMoney>0)
                {

                    this.showState("Win",true)
                    this.changeCoinTxt.string="+"+this.changeCoinTxt.string
                }
                else
                {
                    this.winBg.active=false
                    this.loseBg.active=true
                    
                }
            }
            this.PlayCoinMove()
        }
        else
        {
            this.changeCoinTxt.string="";
            return
        }
    }
    showTotalResult(totalBalance: number) {

      
        this.scheduleOnce(() => {
           this.countMoney=totalBalance
           this.showResult(true) 
           if(this.countMoney>0)
           {
               if(!this.winAction.node.active)
               {
                    this.winAction.node.active=true;
                    this.winAction.play()
               }
                
                this.showState("win",true)
           }
           
        }, 2);
    }
    PlayCoinMove() {

        this.changeCoinBg.stopAllActions();
        let duration = 0.6
        let targetPos=cc.v2(-5,109)
        let callFun = cc.callFunc(function()
        {
            this.sendAck()
        }.bind(this))
        let move = cc.moveTo(duration, targetPos)
        let seq = cc.sequence([move, callFun]);
        this.changeCoinBg.runAction(seq);
        if(this.winAction.node.active)
        {
            this.winAction.node.active=false
        }
        this.showState("",false)
    }
    sendAck()
    {
        //cc.log("seatView","PlayCoinMove")
        this.blackjackLogic.sendAckId(2.5)
    }
    getParentPos() 
    {
        return this.parentPos
    }

    setParentPos(parent:cc.Node)
    {
        this.parentPos = parent
        let pos=this.blackJackView.chipPos.getChildByName(parent.name)
        this.chipPos=pos.getChildByName("seatViewPos")
    }
    setBlackJackTableView(bj:BlackJackTableView) {
        this.blackJackView=bj;
    }
    setPlayerCoin(uid:number, num:number)
    {
        this.posInfo.coinBalance=num;
        
        let self  = this;
        if(this.lastMoney != num){
            
            let caichiCountUp = new CountUp(null, num,{
                startVal:  this.lastMoney,
                decimalPlaces: 0,
                duration: 0.5,
                useEasing: true,
                useGrouping: false,
                smartEasingThreshold: 999,
                smartEasingAmount: 333,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: ''
            })
            
            if(!caichiCountUp.error){
                caichiCountUp.start((n)=>{
                    if (self.nodeIsActive) {
                        this.coinTxt.string=GameUtil.currencyFormatting(parseFloat(n))    
                    }                    
                },)
            }
            this.lastMoney = num
        }
        this.doScheduleOnce(() => {
                self.coinTxt.string=GameUtil.currencyFormatting(num)
            }, 0.55);
        
        if (this.posInfo.isMainSeat) {
            UserDataManager.balanceChangeMessage(num);
        }
        UserDataManager.setUserGameTableCurrency(uid, num);
        
    }
    
    countTime(totalTime:number,cdTime:number)
    {

        this.countTotalTime=totalTime;
        this.reSetCountFrame(0);
        
        this.passTime = this.countTotalTime - cdTime//已经过去的时间
        this.passTime = this.passTime < 0 ? 0:this.passTime;
        this.repeatTime()
        
    }
    repeatTime() {
        let range = 0;
        this.intervalID = this.doSchedule(()=>{
            this.passTime+=cc.director.getDeltaTime();
           
            range = this.passTime / this.countTotalTime
            //cc.log("range:"+range)
            
            this.countFrame.fillRange = -range
            if (this.countFrame.fillRange <= -1) {
                // cc.log("时间自然到")
                this.stopCountTime()
            }
        },0.00,cc.macro.REPEAT_FOREVER);
    }
    reSetCountFrame(range:number) {
        //cc.log("显示框框")
        this.countFrame.node.active = true;
        this.countFrame.fillStart = 0.25;
        this.countFrame.fillRange = range;
        this.countFrame.fillCenter = cc.v2(0.5,0.5);
        this.cancleSlider()
    }
    cancleSlider(){
        if (this.intervalID) {
            this.cancelSchedule(this.intervalID);
            // cc.log('-->>>>取消计时器')
            this.intervalID = null;
        }
    }
    hideOpTimeState(){
        
        this.countFrame.node.active = false;
    }
    stopCountTime()
    {
        this.cancleSlider()
        this.hideOpTimeState()
    }
    
    setLogic(bjLogic:BlackJackTableLogic) {
        if(this.blackjackLogic==null && bjLogic!=null)
        {
            this.blackjackLogic=bjLogic;
        }
    }
    //重新开一局时，清除占位下注数据
    clearNoMainPosInfo() 
    {
        if(this.posInfo==null)
        {
            return
        }
        if(!this.posInfo.isMainSeat)
        {
            this.posInfo=null
        }
    }
    
    showState(str: string,isShow:boolean) {
        switch(str)
        {
            case "StopCard":
                this.stateTxt.string=LanguageManager.t("bj_Stop_Card")
                break;
            case "CompleteBet":
                this.stateTxt.string=LanguageManager.t("bj_Bet_Complete")
                break;
            case "Win":
                this.stateTxt.string=LanguageManager.t("Public_Win")
                break;
        }
        this.stateBg.active = isShow
    }
    
}